import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  useDeleteCertificateNoteByIdMutation,
  useGetCertificateNotesByReferenceIdQuery
} from "../../../../components/common/CertificateNotesGrid/CertificateNotesApi";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";



const AssociationCertificateNotesForm = () => {
  const { associationId } = useParams();
  const [noteObject, setNoteObject] = useState(null);
  const [showCertUpdateModel, setShowCertUpdateModel] = useState(false);
  const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [certificateNoteId, setCertificateNoteId] = useState(null);
  const [deleteNotesApi, { isLoading }] = useDeleteCertificateNoteByIdMutation();


  const {
    data: certificateNotes,
  } = useGetCertificateNotesByReferenceIdQuery(associationId || "");
  const handleDeleteCertificateNotes = async (e: any) => {
    e.preventDefault();

    if (certificateNoteId !== null && certificateNoteId !== '') {
      try {
        await deleteNotesApi(certificateNoteId);
        setShowDeleteConfirm(false);
      } catch (error) {
        console.error('Error deleting certificate note:', error);
      }
    }
  };

  return (


    <div className={"mt-3"}>

      <CommonCertificateNotesForm
        title={"Association Certificate Notes"}
        data={certificateNotes}
        relationalId={associationId}
        count={certificateNotes?.length || 0}
        setShowAddNoteModal={setShowManagementCertificateModal}
        setNoteObject={setNoteObject}
        setShowNoteUpdateModel={setShowCertUpdateModel}
        setNoteId={setCertificateNoteId}
        setShowDeleteConfirm={setShowDeleteConfirm}
      />


      {
        showManagementCertificateModal &&
        <CertNoteAddOrUpdateModal title={"Add Management Company Certificate Note"}
          show={showManagementCertificateModal}
          setShow={setShowManagementCertificateModal}
          relationalId={associationId}
          type={"Assoc"}
          length={certificateNotes && certificateNotes.length + 1}
          btnName="Add" />
      }


      {showCertificateModal &&
        <CertNoteAddOrUpdateModal title={"Add Association Certificate Note"} show={showCertificateModal}
          setShow={setShowCertificateModal} relationalId={associationId}
          type={"Assoc"}
          length={certificateNotes && certificateNotes.length + 1}
          btnName="Add" />}


      {showCertUpdateModel &&
        <CertNoteAddOrUpdateModal title={"Update Association Certificate Note"}
          show={showCertUpdateModel}
          setShow={setShowCertUpdateModel}
          noteObj={noteObject}
          relationalId={associationId}
          btnName={"Update"} type={"Assoc"}

        />
      }
      {showDeleteConfirm && <ConfirmationModal title={"Delete Association Certificate Note"}
        bodyMessage={"Are you sure you want to delete this certificate note?"}
        onSubmit={handleDeleteCertificateNotes}
        show={showDeleteConfirm}
        setShow={setShowDeleteConfirm}
        isLoading={isLoading}
      />
      }
    </div>
  );
};

export default AssociationCertificateNotesForm;